import {Component, CUSTOM_ELEMENTS_SCHEMA, OnDestroy, OnInit} from '@angular/core';
import {RouterLink} from '@angular/router';
import {environment} from '../../../../environments/environment';
import {Subscription} from 'rxjs';
import {AuthenticationService, UserInfo} from '@datev/ngx-dcal';
import {AdobeTrackingService} from '@datev/ngx-adobe-tracking';
import {PersonalService} from '../../shared/service/personal/personal.service';
import {UserContextService} from '../../shared/service/user-context/user-context.service';
import {AppStateService} from 'commons';

import '@datev/dacks/app-switch';
import '@datev/dacks/header';
import '@datev/dacks/client-flyout';
import '@datev/dacks/icon';
import '@datev/dacks/help-menu';
import '@datev/dacks/notifications';
import '@datev/dacks/user-menu';

export type CopilotStage = 'dev' | 'qs' | 'prod';
export type DacksUserContext = 'chancery' | 'client';

export function toDacksUserContext(context: 'CHANCERY' | 'CLIENT'): DacksUserContext {
  return context.toLowerCase() as DacksUserContext;
}

export function getCopilotStage(entryPoint: string, origin: string): CopilotStage {
  const stageSource = `${entryPoint} ${origin}`.toLowerCase();

  if (stageSource.includes('localhost') || stageSource.includes('.dev.datev.de')) {
    return 'dev';
  }

  if (stageSource.includes('.qs.datev.de')) {
    return 'qs';
  }

  return 'prod';
}


@Component({
  selector: 'myupdates-app-header',
    imports: [
        RouterLink
    ],
  templateUrl: './app-header.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  styleUrl: './app-header.component.scss'
})
export class AppHeaderComponent implements OnInit, OnDestroy {

  private readonly loginSubscription?: Subscription;
  private personalizeSubscription?: Subscription;
  private userContextSubscription?: Subscription;
  private readonly activeBusinessPartnerSubscription?: Subscription;

  displayTitle = '';
  feedbackUrl = '';
  readonly copilotStage: CopilotStage;

  displayUser: string | undefined;
  userContext: DacksUserContext | undefined;

  isPersonalized = false;

  constructor(private readonly auth: AuthenticationService,
              private readonly personal: PersonalService,
              private readonly userContextService: UserContextService,
              private readonly adobeTrackingService: AdobeTrackingService,
              readonly appState: AppStateService) {
    this.displayTitle = environment.stageTitle;
    this.feedbackUrl = environment.passiveTMA;
    this.copilotStage = getCopilotStage(environment.entryPoint, window.location.origin);
  }

  ngOnInit(): void {
    this.userContextSubscription = this.userContextService.getUserContext().subscribe(context => {
      this.userContext = toDacksUserContext(context);
    });

    this.personalizeSubscription = this.appState.isPersonalized$.subscribe(isPersonalized => {
      this.isPersonalized = isPersonalized;
      this.initializePersonalData();
    });

    this.auth.subscribeIdentityChanged(() => {
      this.initializePersonalData();
    });
  }

  ngOnDestroy(): void {
    this.activeBusinessPartnerSubscription?.unsubscribe();
    this.loginSubscription?.unsubscribe();
    this.personalizeSubscription?.unsubscribe();
    this.userContextSubscription?.unsubscribe();
  }

  private initializePersonalData(): void {
    if (this.isPersonalized) {
      this.getUserInfo();

      // aktuell ist der Aufruf hier notwendig, da sonst die Businesspartner nicht aktuell sind und
      // die Personalisierung nicht gegriffen hat
      this.personal.refreshDefaultBusinessPartner();
    }
  }

  async login(): Promise<void> {
    await this.adobeTrackingService.publishClickEvent('loginState:NavBar:loginButtonClick');
    await this.auth.login();
  }

  async logout(): Promise<void> {
    await this.adobeTrackingService.publishClickEvent('loginState:NavBar:logoutButtonClick');
    this.auth.logout();
  }

  private getUserInfo(): void {
    this.auth.getUserInfo().then((userInfo: UserInfo) => {
      this.displayUser = `${userInfo.name}`;
    }).catch(() => console.log('getUserInfo error'));
  }

}
